<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="70%">
      <v-card>
        <v-card-title class="primary white--text">Asignar Categoria Moodle</v-card-title>
        <v-card-text class="pa-4">
          <p v-html="datamsg"></p>
          <v-combobox
            v-model="categoria"
            :items="categorias"
            item-text="name"
            :search-input.sync="search"
            label="Buscar (Min. 4 Caracteres)"
            hint="Escriba y Seleccione La Categoria de Moodle"
            outlined>
          </v-combobox>
          <p class="text-center ma-0 pa-0 red--text">
            <small> {{ msgerr }} </small>
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" rounded v-if="categoria" @click="assignCategoriaToPrograma">
            <v-icon> mdi-plus</v-icon> Asignar Categoria
          </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
export default {
  props: ['programa', 'plataformas'],
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      // api_rest_moodle: process.env.VUE_APP_// ,
      categoria: null,
      categorias: [],
      search: '',
      dialog: false,

      datamsg: '',
      plataforma: {},
      msgerr: '',
    };
  },
  watch: {
    search(valor = null) {
      this.msgerr = '';
      if (!this.plataforma?.id) {
        this.plataformaprograma();
      } else {
        if (valor && valor.length > 3) {
          // let url = `${this.plataforma?.direccion}/esam/categories`;
          let url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
            this.plataforma?.id
          }/categories`;
          xaxios
            .post(url, { search_text: `${valor}` })
            .then(({ data }) => (this.categorias = data))
            .catch(({ response }) => {
              window.console.log(response.data.error);
              this.msgerr = response.data.error;
            });
        } else {
          this.categorias = [];
          this.search = null;
        }
        //window.console.log('plataformas', this.plataformas)
      }
    },
  },
  methods: {
    assignCategoriaToPrograma() {
      // window.console.log('assignCategoriaToPrograma', this.programa);

      this.$root.$confirm.open('Asignar Categoria', 'Estas seguro de asignar?', { color: 'orange' }).then((confirm) => {
        if (this.programa && this.categoria && confirm) {
          const sql = gql`mutation{asignarCategoriaMoodle(input:{programa_id: ${this.programa.id},course_category_id: ${this.categoria.id}}){ ok,  errors{message} programa{id,course_category_id} }}`;
          this.$apollo
            .mutate({ mutation: sql })
            .then(({ data: { asignarCategoriaMoodle } }) => {
              if (asignarCategoriaMoodle.ok) {
                this.$root.$notify.show(`ID ${this.categoria.id} de Categoria Asignado Exitosamente`, {
                  color: 'success',
                });
                this.programa.course_category_id = this.categoria.id;
                this.programa.estado = this.programa.estado ? this.programa.estado : false;
                this.$emit('reloadCategoria');
              } else {
                asignarCategoriaMoodle.errors.forEach((error) => {
                  this.$root.$notify.show('ERROR:' + error.message, { color: 'red' });
                });
              }
              this.dialog = false;
            })
            .catch((err) => window.console.error(err));
        }
      });
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.msgerr = '';
    },
    plataformaprograma() {
      let plataforma_id = this.programa.plataforma_id;
      this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
      this.datamsg = this.plataforma
        ? `<b>Plataforma</b>: ${this.plataforma?.nombre} [${this.plataforma?.direccion}]`
        : 'Plataforma no asignada o no encontrada';
    },
  },
};
</script>
